/* eslint-disable no-nested-ternary */
import { BlueBirdTheme, Checkbox, Typography } from "@kitbird/core";
import {
  Control, Controller, UseFormSetValue,
} from "react-hook-form";
import {
  CardBody, CardContainer, CardHeader, CardSelectAll, CardTitle,
} from "../BusinessCard";
import { SelectionGroupBody, SelectionGroupContainer, SelectionGroupHeader } from "../../BusinessTrx.styled";
import { IBusinessTrxFormValues } from "../../types";
import BaseLoading from "../../../../../components/Loading/BaseLoading";
import EmptyState from "../EmptyState";
import { useFormBusinessTrx } from "../../FormBusinessTrxProvider";

interface StepPoolSelectionProps {
  control: Control<IBusinessTrxFormValues>;
  setValue: UseFormSetValue<IBusinessTrxFormValues>;
}

const StepPoolSelection = ({ control, setValue }: StepPoolSelectionProps) => {
  const {
    isFetchingPool,
    allPoolIds,
    resPoolByArea,
    pools,
    selectedPoolIds,
    isEditMode,
  } = useFormBusinessTrx();

  return (
    <CardContainer>
      <CardHeader>
        <CardTitle>
          <Typography level={4} fontWeight="bold" color={BlueBirdTheme.colors.gray.subtitle}>
            Pilih pool
          </Typography>
        </CardTitle>
        {!isEditMode && (
          <CardSelectAll>
            <Controller
              name="pilihSemuaPool"
              control={control}
              render={({ field: { value, onChange, ...restField } }) => (
                <Checkbox
                  {...restField}
                  checked={value}
                  onChange={(e) => {
                    const { checked } = e.target;
                    onChange(checked);
                    setValue("selectedPoolIds", checked ? allPoolIds : []);
                  }}
                  label="Pilih semua pool"
                  disabled={isFetchingPool || allPoolIds.length === 0}
                />
              )}
            />
          </CardSelectAll>
        )}
      </CardHeader>
      <CardBody>
        {isFetchingPool ? (
          <BaseLoading />
        ) : resPoolByArea.length ? (
          Object.entries(pools).map(([area, poolList]) => (
            <SelectionGroupContainer key={area}>
              <SelectionGroupHeader>
                <Typography level={4} fontWeight="bold" color={BlueBirdTheme.colors.gray.subtitle}>
                  {area}
                </Typography>
                <div style={{ marginLeft: "auto", display: isEditMode ? "none" : "block" }}>
                  <Checkbox
                    label="Pilih semua"
                    checked={poolList.length > 0 && poolList
                      .every((p) => selectedPoolIds.includes(p.pool_id))}
                    onChange={(e) => {
                      const allPoolIdsInArea = poolList.map((p) => p.pool_id);
                      const currentSelected = new Set(selectedPoolIds);
                      if (e.target.checked) {
                        allPoolIdsInArea.forEach((id) => currentSelected.add(id));
                      } else {
                        allPoolIdsInArea.forEach((id) => currentSelected.delete(id));
                      }
                      setValue("selectedPoolIds", Array.from(currentSelected));
                    }}
                  />
                </div>
              </SelectionGroupHeader>
              <SelectionGroupBody gridTemplateColumns="none">
                {poolList.map((pool) => (
                  <Controller
                    key={pool.pool_id}
                    name="selectedPoolIds"
                    control={control}
                    defaultValue={[]}
                    render={({ field: { value, onChange } }) => (
                      <Checkbox
                        label={`${pool.pool_id} - ${pool.pool_name}`}
                        checked={value && value.includes(pool.pool_id)}
                        onChange={(e) => {
                          if (isEditMode) {
                            onChange(e.target.checked ? [pool.pool_id] : []);
                          } else {
                            onChange(e.target.checked
                              ? [...(value || []), pool.pool_id]
                              : value?.filter((id: string) => id !== pool.pool_id));
                          }
                        }}
                      />
                    )}
                  />
                ))}
              </SelectionGroupBody>
            </SelectionGroupContainer>
          ))
        ) : (
          <EmptyState />
        )}
      </CardBody>
    </CardContainer>
  );
};

export default StepPoolSelection;
